export default "__VITE_ASSET__DMzDB2Ty__"